import {
  Profile,
  RevealProgress,
} from "@redotech/redo-reveal-workflow/workflows/reveal";
import * as z from "zod";

/**
 * Ad-hoc Recognize lookup: start a reveal for a person named on the merchant's
 * dashboard, then poll it (the engine runs for minutes, so it's start + poll).
 */

/** Structured lookup address — each field maps straight onto RevealRequest. */
export const RecognizeLookupAddress = z.object({
  street1: z.string().optional(),
  street2: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  zip: z.string().optional(),
  country: z.string().optional(),
});
export type RecognizeLookupAddress = z.infer<typeof RecognizeLookupAddress>;

export const startCustomerReveal = {
  name: "startCustomerReveal" as const,
  input: z.object({
    name: z.string().min(1),
    address: RecognizeLookupAddress.optional(),
    email: z.string().optional(),
  }),
  output: z.object({
    /** Temporal workflow id to hand back to getCustomerReveal. */
    workflowId: z.string(),
  }),
};

/** Mirrors RevealResponse.status, plus `running` for a workflow still in flight. */
export const RevealLookupStatus = z.enum([
  "running",
  "resolved",
  "partial",
  "not_found",
  "failed",
]);
export type RevealLookupStatus = z.infer<typeof RevealLookupStatus>;

export const getCustomerReveal = {
  name: "getCustomerReveal" as const,
  input: z.object({ workflowId: z.string() }),
  output: z.object({
    status: RevealLookupStatus,
    /** Live pipeline progress while running; the final snapshot once settled. */
    progress: RevealProgress.nullable(),
    // Reveal match-confidence, not the restriction_confidence DB enum.
    //redontIgnore
    confidenceBand: z.enum(["high", "medium", "low"]).nullable(),
    /** Populated only once status is resolved/partial. */
    profile: Profile.nullable(),
    generatedAt: z.string().nullable(),
  }),
};
